import { Flex, ScrollArea, Tabs, Text } from '@mantine/core'
import Image from 'next/image.js'
import React from 'react'
import useSWR from 'swr'
import { useLocaleContext } from '../context/locale'
import { useTranslations } from 'next-intl'
import StyledTabs from './styled_tabs.js'

const fetcher = (url) => fetch(url).then((res) => res.json())

const SourcesTabs = ({ id, type }) => {
  const t = useTranslations('SourcesTabs.tabs')
  const { data: externalData } = useSWR(
    `/api/api_ext/content/external_ids/bb?id=${id}`,
    fetcher
  )

  const { country } = useLocaleContext()

  return (
    <StyledTabs defaultValue="external_sources">
      <ScrollArea type="auto" offsetScrollbars={false} scrollbarSize={0}>
        <Tabs.List mt={-10} mb={18} style={{ display: 'flex', flexwrap: 'nowrap' }}>
          <Tabs.Tab value="external_sources">{t('externalSources')}</Tabs.Tab>
          <Tabs.Tab value="distributors">{t('distributors')}</Tabs.Tab>
          <Tabs.Tab value="marketplaces">{t('marketplaces')}</Tabs.Tab>
          <Tabs.Tab value="illegal">{t('illegalSitesDetected')}</Tabs.Tab>
        </Tabs.List>
      </ScrollArea>

      <Tabs.Panel value="external_sources" ml={{ base: '0.5rem', md: '1rem' }}>
        <Flex
          align="center"
          gap={{ base: '12px', md: '24px' }}
          wrap="wrap"
          justify="flex-start"
        >
          {externalData?.databases?.map((db) => (
            <a
              key={db.id}
              href={`https://click.bb-media.com/redirect?tag=StreamDiscover&url=${encodeURIComponent(
                db.url
              )}&id=${id}&type=${type}&country=${country}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                width={50}
                height={50}
                src={db.logo}
                alt={db.name}
                style={{
                  borderRadius: '8px'
                }}
              />
            </a>
          ))}
        </Flex>
      </Tabs.Panel>

      <Tabs.Panel value="distributors" ml={{ base: '0.5rem', md: '1rem' }}>
        <Flex
          align="center"
          gap={{ base: '12px', md: '24px' }}
          wrap="wrap"
          justify="flex-start"
        >
          {externalData?.distributors?.length > 0 ? (
            externalData.distributors.map((distributor) => (
              <a
                key={distributor.id}
                href={`https://click.bb-media.com/redirect?tag=StreamDiscover&url=${encodeURIComponent(
                  distributor.url
                )}&id=${id}&type=${type}&country=${country}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  width={50}
                  height={50}
                  src={distributor.logo}
                  alt={distributor.name}
                  style={{
                    borderRadius: '8px'
                  }}
                />
              </a>
            ))
          ) : (
            <Text size="sm" span>
              {t('notAvailable')}
            </Text>
          )}
        </Flex>
      </Tabs.Panel>

      <Tabs.Panel value="marketplaces" ml={{ base: '0.5rem', md: '1rem' }}>
        <Flex
          align="center"
          gap={{ base: '12px', md: '24px' }}
          wrap="wrap"
          justify="flex-start"
        >
          {externalData?.marketplaces?.length > 0 ? (
            externalData.marketplaces.map((marketplace) => (
              <a
                key={marketplace.id}
                href={`https://click.bb-media.com/redirect?tag=StreamDiscover&url=${encodeURIComponent(
                  marketplace.url
                )}&id=${id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  width={50}
                  height={50}
                  src={marketplace.logo}
                  alt={marketplace.name}
                  style={{
                    borderRadius: '8px'
                  }}
                />
              </a>
            ))
          ) : (
            <Text size="sm" span>
              {t('notAvailable')}
            </Text>
          )}
        </Flex>
      </Tabs.Panel>

      <Tabs.Panel value="illegal" ml={{ base: '0.5rem', md: '1rem' }}>
        <Text size="sm" span>
          {externalData?.total_streaming_services_piracy || t('notAvailable')}
        </Text>
      </Tabs.Panel>
    </StyledTabs>
  )
}

export default SourcesTabs
